module.exports = __webpack_public_path__ + "static/circle-logo-white-b7ca407cbb7395f0bfe5f9708d030666.svg";